<template>
  
  <div class="container">

    <div class="row" id="timeline">

        <div class="col-lg-8 mt-0">
            <h2 class="h3">{{ $t("timeline_title") }}</h2>
            <p class="ontario-lead-statement mb-0">{{ $t("timeline_description") }}</p>
        </div><!-- col-lg-8 -->
       
        <hr class="bold_hr_super ml-3 mr-3">

    </div><!-- row -->

    <section v-if="errored">
        <p>{{ $t("message_error") }}</p>

    </section>
    
    <section v-else>

      <button class="ontario-button ontario-button--secondary sm_home_filter d-none mb-5" v-on:click="isShow =!isShow">{{ $t("cat_show") }}</button>      

      
      <div class="row pr-3">

        <div v-if="isShow" class="cat_show col-lg-3 mb-5 h-100">

          <h3 class="h4 mb-5">{{ $t("timeline_stream") }}</h3>
          <ul class="time_cat pl-0">
              <li v-for="stream in streams" v-bind:key="stream.id">
                <router-link class="a_no_line" :to="{ name: 'stream', params: { stream_id: stream.id } }">{{ stream.name }}</router-link><hr class="mb-3 mt-3"/>
              </li>
          </ul>

        </div><!-- col-lg-4 -->

        <div class="col-lg-8 offset-lg-1 padding-large-0">

          <streams></streams>

        </div><!-- col-lg-8 -->

      </div><!-- row -->

    </section>

  </div>

</template>

<script>
import Streams from '../components/Streams.vue'

export default {

  components: {
    Streams
  },
  data () {
    return {
      streams: [],
      loading: true,
      errored: false, 
      isShow:true
    }
  },
  methods: {
    fetchStreamData () {
      this.loading = true
      this.$axios
        .get(process.env.VUE_APP_ROOT_API + 'streams')
        .then(response => {
          this.streams = response.data.data
        })
        .catch(error => {
          console.log(error)
          this.errored = true
        })
        .finally(() => (
          this.loading = false
        ))
    },

    onResize() {
    if (window.innerWidth > 991) {
      this.isShow = true
    } else {
      this.isShow = false
    }
  }
  },
  mounted () {
    this.fetchStreamData()
    this.onResize()
  },

  created() {
    window.addEventListener('resize', this.onResize)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
}
</script>
